var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridLayerGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95297 0H6.54545V2.40752H8.95297V0ZM20.3887 0H10.1567V2.40752H20.3887V0ZM21.5925 0V2.40752H24V0H21.5925ZM21.5925 15.047V17.4545H24V15.047H21.5925ZM24 3.61129V13.8433H21.5925V3.61129H24ZM5.68024 3.27273H3.27273V5.68025H5.68024V3.27273ZM17.116 3.27273H6.884V5.68025H17.116V3.27273ZM18.3198 3.27273V5.68025H20.7273V3.27273H18.3198ZM18.3198 18.3198V20.7273H20.7273V18.3198H18.3198ZM20.7273 6.88401V17.116H18.3198V6.88401H20.7273ZM3.61128 6.54545H13.8433V8.95298H3.61128V6.54545ZM15.047 8.95298V6.54545H17.4545V8.95298H15.047ZM13.8433 10.1567H3.61128V20.3887H13.8433V10.1567ZM2.40752 20.3887V10.1567H0V20.3887H2.40752ZM0 24V21.5925H2.40752V24H0ZM3.61128 21.5925H13.8433V24H3.61128V21.5925ZM15.047 24V21.5925H17.4545V24H15.047ZM17.4545 20.3887V10.1567H15.047V20.3887H17.4545ZM0 6.54545H2.40752V8.95298H0V6.54545Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridLayerGroup);
export default __webpack_public_path__ + "static/media/GridLayerGroup.b751717ee1c405d1d1022c846beeaf15.svg";
export { ForwardRef as ReactComponent };